// Copyright © 2022 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapImage, BootstrapLink, BootstrapNav } from '../../../dsl/front'
import { Image, LineModuleHeader } from '../../_contracts'

/**
 * Component capable of rendering the `TeaserBoxModule's` header.
 *
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Component<LineHeaderContent>({
  name: 'LineHeaderContent',
  components: { BootstrapImage, BootstrapNav, BootstrapLink },

  template: `
    <BootstrapLink v-if="headerLink" :link="{target: { path: headerLink }}" style="text-decoration: none">
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </BootstrapLink>
    <span v-else>
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </span>
  `
})
export class LineHeaderContent extends Vue {
  @Prop({ type: Object, required: false })
  public headerImage!: Image

  @Prop({ type: String, required: false })
  public headerLink!: string

  @Prop({ type: String, required: true })
  public text!: LineModuleHeader['text']
}
